import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { GraphQL } from "@rpi/openapi-api";
import { Body } from "../../../../components/Typography";
import { formatCurrency } from "../../../../utils/misc.util";

const useStyles = createStyles(() => ({
  lineItem: {
    display: "flex",
    gap: tokens.spacing[1],
    paddingBottom: 2,
  },
  borderDashed: {
    borderBottom: `1px dashed ${tokens.color.primitive.light.gray[200]}`,
  },
  borderSolid: {
    borderBottom: `1px solid ${tokens.color.primitive.light.gray[400]}`,
  },
  value: {
    flex: "1 0 0",
    textAlign: "right" as const,
    minWidth: 0,
  },
}));

const BORDER_CLASS_KEYS = {
  dashed: "borderDashed",
  solid: "borderSolid",
  none: undefined,
} as const;

interface PricingLineItemProps {
  label: string;
  currency?: GraphQL.SupportedCurrency | null;
  amount?: number | null;
  border?: keyof typeof BORDER_CLASS_KEYS;
  prefix?: string;
}

export const PricingLineItem: React.FC<PricingLineItemProps> = ({
  label,
  currency,
  amount,
  border = "dashed",
  prefix,
}) => {
  const { classes, cx } = useStyles();
  const borderClassKey = BORDER_CLASS_KEYS[border];
  return (
    <div className={cx(classes.lineItem, borderClassKey && classes[borderClassKey])}>
      <Body>{label}</Body>
      <Body className={classes.value}>
        {prefix}
        {formatCurrency(currency, amount)}
      </Body>
    </div>
  );
};
